import  React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import arrow from 'images/iconmoon/SVG/arrow.svg';

import './style.css';

class StoriesTemplate extends PureComponent {
  static PropTypes = {
    remarkedTitle: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    imagePosition: PropTypes.string.isRequired,
    image : PropTypes.string.isRequired
  }
  render() {
    const { remarkedTitle, header, title, description, pathname, imagePosition, image } = this.props;

    return (
      <div className={`l-stories-template ${imagePosition}`}>
        <section className="image">
          <div className="background-image">
            <img className="main-image" alt="retina" src={require(`images/stories/${image}.png`)} />
          </div>
        </section>
        <section className={`description ${imagePosition}`}>
          <h1 className="story-title">{header}</h1>
          <span className="story-description" dangerouslySetInnerHTML={{ __html: description }} />
          <Link className="product-link" to={pathname}>Go to product<img className="icon" src={arrow} alt={arrow} /></Link>
        </section>
      </div>
    )
  }
}


export default StoriesTemplate;



// WEBPACK FOOTER //
// ./src/pages/stories/template/index.js